// Premium Super C — heavy-duty truck-chassis coach imagery.
//
// Iteration 109: Owner-approved Super C motorhome photography landed
// via the canonical manifest (see /lib/photos/manifest.js).  This module
// now only exposes true Super C imagery on Freightliner / International
// chassis (Newmar Supreme Aire, Newmar Superstar, and coordinated
// Super C builds).  The previous Prevost X3-45 stand-ins have been retired.
import { _ASSET_BASE } from "./_base";

const SC_HERO      = `${_ASSET_BASE}/veobwrii_IMG_5636.jpeg`; // Newmar Supreme Aire · Freightliner M2
const SC_ACCENT    = `${_ASSET_BASE}/71cs8mst_IMG_5637.jpeg`; // Super C · Freightliner Cascadia · palms
const SC_GALLERY_1 = `${_ASSET_BASE}/y33darmv_IMG_5638.jpeg`; // Super C · Freightliner M2 · black awning
const SC_GALLERY_2 = `${_ASSET_BASE}/ps2iyy67_IMG_5639.jpeg`; // Newmar Superstar · burgundy rear
const SC_GALLERY_3 = `${_ASSET_BASE}/4tfhvvqb_IMG_5641.jpeg`; // Super C · International MV · black/silver

export const PREMIUM_SUPER_C_PHOTOS = [
  SC_HERO,
  SC_ACCENT,
  SC_GALLERY_1,
  SC_GALLERY_2,
  SC_GALLERY_3,
];

const premiumSuperC = {
  hero: SC_HERO,
  accent: SC_ACCENT,
  gallery: [SC_GALLERY_1, SC_GALLERY_2, SC_GALLERY_3],
  card: SC_HERO,
  social: SC_HERO,
};
export default premiumSuperC;
